import React, { useEffect, useState, useRef, useContext } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { AuthContext } from "../../auth/auth-context";
import SocialAuthButtons from "../../components/SocialAuthButtons";

const Login = () => {
  const { login } = useContext(AuthContext);

  const { REACT_APP_BACKEND_URL } = process.env;
  const LOGIN_URI = "/users/login";

  const userRef = useRef();
  // todo: add focus change for error (accessibility)

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    userRef.current.focus();
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(REACT_APP_BACKEND_URL + LOGIN_URI);
    fetch(REACT_APP_BACKEND_URL + LOGIN_URI, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log(data);
        if (data.message === "Authentication Success") {
          // Set the token in local storage
          // console.log(data);
          try {
            console.log("Setting token");
            login(data.token);
          } catch (e) {
            console.log(e.message);
          }

          // Clear the form on success
          setEmail("");
          setPassword("");

          // Redirect to homepage
          console.log("Redirecting to homepage, after successful login");
          window.location.href = "/account/my-account";
        } else {
          setError(data.error);
        }
      })
      .catch((error) => {
        setError(error.message);
      });
  };

  return (
    <div className='flex py-10 md:py-20'>
      <Helmet>
        <title>Log In | tastebud.ee</title>
        <meta name='robots' content='noindex' />
        <meta name='description' content='Log in to your tastebud.ee account to manage your allergen menus, locations and QR codes.' />
        <link rel='canonical' href='https://tastebud.ee/account/login' />
      </Helmet>
      <div className='flex-1 h-auto'></div>
      <div className='flex-initial h-auto w-96 min-w-100 bg-slate-50 rounded border border-slate-200 p-10 shadow-lg text-center'>
        <h1 className='text-center text-slate-800 font-medium text-xl pb-6'>Account Login</h1>
        <SocialAuthButtons />
        <form onSubmit={handleSubmit}>
          <div className='p-2'>
            <label className='block text-center mb-5 mx-auto'>
              <span className='text-gray-700 text-center mb-4 text-sm'>Email address</span>
              <input
                type='email'
                id='email'
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                name='email'
                required
                className='px-2 py-1 block text-gray-700 w-72 mx-auto border-[#D6D6D6] bg-white rounded-lg focus:ring-black'
                autoComplete='email'
                ref={userRef}
              />
            </label>
            <label className='block text-center mb-5 mx-auto'>
              <span className='text-gray-700 text-center mb-4 text-sm'>Password</span>
              <input
                type='password'
                id='password'
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                name='password'
                placeholder=''
                required
                className='px-2 py-1 block text-gray-700 w-72 mx-auto border-[#D6D6D6] bg-white rounded-lg focus:ring-black'
                autoComplete='current-password'
              />
            </label>
          </div>
          {/* <div className='p-2 hidden' id='warning-auth'>
            <p className='text-sm text-center mb-4 text-red-500'>The login details you entered are incorrect, please try again, create an account or reset your password.</p>
          </div> */}
          {error && <p>{error}</p>}
          <div className='items-center px-4 py-3'>
            <button type='submit' id='login' className='bg-cyan-800 hover:bg-white text-white hover:text-cyan-800 rounded-md px-6 py-2 hover:border-cyan-800 border border-white'>
              Login
            </button>
            {/* <p className='py-3 px-5 m-0 text-sm hover:underline'>
              <a href='/forgot-password'>Forgot password? [BROKEN]</a>
            </p> */}
            <p className='py-3 px-5 m-0 text-sm hover:underline'>
              <Link to='/account/register'>Need an account?</Link>
            </p>
          </div>
        </form>
      </div>
      <div className='flex-1 h-auto'></div>
    </div>
  );
};

export default Login;
